<template>
    <div id="main_div" class="all-feature-page-container">
        <section id="feature-page" class="feature-page vertical-scrolling">
                    <div class="convert-to-text-container col-md-12 col-sm-12">
                      
                        <div class="convert-to-text-left">
                            <div class="text-white">
                                <div class="contain">
                                    <h1 class="text-white">
                                        <slot name="convert_to_text_title"></slot>
                                    </h1>
                                    <h2 class="slide-desc">
                                        <slot name="convert_to_text_desc"></slot>
                                    </h2>
                                    <a class="btn btn-custom" :href="loginUrl" type="button">
                                        <slot name="start_your_trial"></slot>
                                    </a>
                                    <!-- <button @click="onLogin" href="https://www.taption.com" class="btn btn-custom ">
                                        
                                   
                                        <slot name="start_your_trial"></slot>
                                    </button> -->
                                   

                                    <!-- <video playsinline class="intro-video" :src='"@/assets/video/landing_ch.mp4"' autoplay frameborder="0" height="350" width="575" muted></video> -->
                                    <!-- <slot name="intro_video"></slot> -->
                                </div>
                            </div>
                        </div>
                      


                        <div class="convert-to-text-right">
                            <div class="media-placeholder">
                                    <!-- <img alt="feature hero" :src='"@/assets/images/features/convert-text-hero-zh.png"' width="500"> -->
                                        <slot name="hero_image"></slot>
                                    </div>
                        </div>

                    </div>


                    <div class="additional-container col-md-12 col-sm-12">
                        <slot name="additional"></slot>
                    </div>
                    <!-- <div class="transcription-page-container feature-section col-md-7 col-sm-12">
                        <div class="transcription-contain">
                            <div class="text-white">
                                <div class="contain">
                                    <h1 class="text-white">
                                        <slot name="convert_to_text_title"></slot>
                                    </h1>
                                    <h4 class="slide-desc">
                                        <slot name="convert_to_text_desc"></slot>
                                    </h4>

                                    <button @click="onLogin" class="btn btn-custom ">
                                   
                                        <slot name="start_your_trial"></slot>
                                    </button>
                                    <div class="media-placeholder">
                                        <slot name="hero_image"></slot>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div> -->

                    <div class="feature-page-three-conatiner feature-section column col-md-10 col-sm-12">
          <h1 class="text-white">
            <!-- 轉文字三步驟 -->
            <!-- <slot name="three_step_title"></slot> -->
        </h1>
                    <div class="feature-page-group top flex">
                <div class="feature-page-container col-md-4 col-sm-12 col-xs-12">
                     <div class="feature-page-group-header">
                        <h2 class="feature-page-group-title">
                            <!-- 選擇上傳影音檔 -->
                            <slot name="step_one"></slot>
                        </h2>
                            <slot name="step_one_image"></slot>
                       <!-- <img alt="feature image explain 1" :src='"@/assets/images/features/select_source_zh.png"'> -->
                        <h3>
                            <!-- 從電腦，Youtube，Google Drive或Zoom選擇影片或錄音後上傳。 -->
                            <slot name="step_one_desc"></slot>
                        </h3>
                      
                    </div>
                </div>
                <div class="feature-page-container col-md-4 col-sm-12 col-xs-12">
                     <div class="feature-page-group-header">
                        <h2 class="feature-page-group-title">
                            <!-- 選擇轉成文字方式 -->
                            <slot name="step_two"></slot>
                        </h2>
                            <slot name="step_two_image"></slot>
                       <!-- <img alt="feature image explain 2" :src='"@/assets/images/features/select_split_zh.png"'> -->
                        <h3>
                            <slot name="step_two_desc"></slot>
                        </h3>
                     
                    </div>
                </div>

                <div class="feature-page-container col-md-4 col-sm-12 col-xs-12">
                     <div class="feature-page-group-header">
                        <h2 class="feature-page-group-title">
                            <slot name="step_three"></slot>
                        </h2>
                            <slot name="step_three_image">

                            </slot>
                        <h3>
                            <slot name="step_three_desc"></slot>
                        </h3>
                     
                    </div>
                </div>
            </div>
            </div>





            <div class="feature-how-to-conatiner feature-section column col-md-12 col-sm-12">
                <h1 class="text-white sub-title">
                    <slot name="feature_tutorial_title"></slot>
                </h1>

                <div class="feature-page-group feature-page-tutorial">
                    <p style="display:block;color:#797676;">

                        <slot name="feature_tutorial_desc"></slot>
                    </p>

                    <div class="feature-tutorial-container">
                        <slot name="feature_tutorial_media">

                        </slot>
    
                    </div>
                </div>
        </div>

            <div class="feature-why-conatiner feature-section column col-md-12 col-sm-12">
                <h1 class="text-white sub-title">
                    <slot name="feature_extra_title"></slot>
                </h1>
                <div class="feature-page-group feature-page-extra">
           
                    <slot name="feature_extra_desc"></slot>
          
                </div>
                <div class="feature-why-container">
                        <slot name="feature_why_media">

                        </slot>
    
                    </div>

            </div>

            <div class="feature-what-to-conatiner feature-section column col-md-12 col-sm-12">
                <h1 class="text-white sub-title">
                    <slot name="feature_what_title"></slot>
                </h1>

                <div class="feature-page-group feature-page-what">
                    <p style="display:block;color:#797676;">

                        <slot name="feature_what_desc"></slot>
                    </p>

                   
                </div>
        </div>
        </section>

    </div>
</template>

<script>

import textHelper from "@/utils/textManager";
export default {
    name: "FeaturePage",
    data() {
        return {
       // isHidden: true,
        activeSrc: null
        };
    },
    computed:{
        loginUrl(){
            return textHelper.getAppLoginUrl();
        }
    },
    methods:{
        onLogin(){
            window.location.href = textHelper.getAppLoginUrl();
        }
    },
    mounted(){
        this.isHidden = true;
    }

}
</script>
<style scoped>
.feature-page-group.flex{
    display: flex;
}

.feature-page-group{
    /* display: flex; */
    padding-top:20px;
}
.feature-page-group-header img{
  position:block;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  text-align: center;
  top:-90px;
  opacity: 1;
 max-height:120px;
 /* max-width:60%; */
  z-index:-1;
}
.feature-page-group-title{
    margin-top:20px;
    font-size:26px;
    letter-spacing: 1px;
    min-height:56px;
    text-transform: capitalize;
}

.feature-page-group-header h3{
    text-transform: none;
}
.feature-why-container img,
.feature-page-tutorial img{
    width:560px;
    height:315px;
    /* border:1px solid black; */
    border-radius: 5px;
    cursor:pointer;
}

.feature-page-tutorial .collaborate-custom-permission-dialog{
    width:100%;
    text-align: center;
    margin-bottom:30px;
}

.feature-page-tutorial img.custom-permission{
    height:480px;
    width:auto;
    padding:10px;
  box-shadow: 0 4px 16px 0 rgba(96, 101, 123, 0.24) !important;
  -webkit-box-shadow: 0 4px 16px 0 rgba(96, 101, 123, 0.24) !important;
    /* border:1px solid black; */
    border-radius: 5px;
    cursor:pointer;
}

.feature-page-tutorial p{
    text-align: left;
}

.feature-why-container,
.feature-tutorial-container{
    /* display:table;
 text-align: center; */
    margin-top:60px;
    margin-bottom:40px;
    position:relative;
}
.feature-page-extra{
    color:#797676;
}
.media-placeholder{
    margin-top:30px;
}
.media-placeholder img{
    border-radius: 5px;
}
.convert-to-text-container{
    display:flex;
    margin:0 auto;
    padding-top:100px;
    padding-left:100px;
    padding-right:100px;
    padding-bottom: 50px;
}

.convert-to-text-right,
.convert-to-text-left{
    width:50%;
    display:table;
}
.convert-to-text-left > div{
    display:table-cell;
    vertical-align: middle;
}
.convert-to-text-left{
    text-align: left;
    padding-left:70px;
}
.convert-to-text-left .slide-desc{
    padding:20px 0px;
}

.feature-page .play-button img{
  width:76px;
  height:76px;
}
.feature-page .play-button{
 /* display:table-cell;
 vertical-align: middle; */
 position: absolute;
 cursor: pointer;
  width:76px;
  height:76px;
    top:  calc(50% - 38px);
    left: calc(50% - 38px);
}
.feature-page .play-button::before{
  box-shadow: 0 0 3px 3px #e8e8e8;
    position: absolute;
    content: "";
    width: 76px;
    height: 76px;
    bottom: auto;
    left: auto;
    border-radius: 50%;
    z-index: 0;
    -webkit-animation: none;
    animation: none;
}

.feature-how-to-conatiner,
.feature-why-conatiner,
.feature-what-to-conatiner{
    padding: 0px 200px;
}

.all-feature-page-container{
    opacity: 1;
    z-index: 2;
}
.all-feature-page-container::before{
    background:url(../assets/images/background/add-subtitles-background.webp);
    background-size:cover;
    background-repeat: no-repeat;
    position:absolute;
    content:'';
    z-index:-1;
    inset:0;
    opacity: 0.2;
}

@media (max-width: 992px) {
.feature-page .btn{
    margin: 0 auto;
    margin-top:20px;
}

.feature-page h3,
.feature-page h4.slide-desc,
.feature-page p{
    padding:0px 10px;
}
  .convert-to-text-container{
    padding-left:10px;
    padding-right:10px;
  }
  .convert-to-text-container h1,
  .convert-to-text-container h4{
    width:100%;
    text-align: center;
  }
  .convert-to-text-left{
    padding-left:0px;
    width:100%;
    text-align: center;
  }
  .convert-to-text-right{
    width:0%!important;
  }
  .convert-to-text-right img{
    display:none;
  }

  .feature-page-group{
    display:block!important;
  }
  .feature-page-container{
    display:block!important;
    padding-bottom:100px;
  }

  .add-subtitles-page .feature-page-three-conatiner{
        display:none;
        height:0px;
        max-height: 0px;
    }


    .feature-how-to-conatiner,
.feature-why-conatiner,
.feature-what-to-conatiner{
    padding: 0px;
}

.all-feature-page-container{
    opacity: 1;
}
.all-feature-page-container::before{
    background:none;
}
.feature-how-to-conatiner{
    padding:0px 30px;
}
}

@media (max-width: 600px) {
    .feature-tutorial-container iframe,
    .feature-tutorial-container img{
        width: 100%;
        height: auto;
    }

}
</style>

<style>


section {
  padding-bottom: 50px;
  padding-top: 0px;
  margin-top: 80px !important;
}

.taption .feature-page {
  min-height: auto !important;
  height: auto !important;
  padding-bottom: 0px;
}

.taption .feature-page h1 {
  font-size: 53px;
  text-decoration: none;
  text-transform: none;
  font-weight: 400;
}

.taption .feature-page h1.sub-title {
  font-size: 40px;
  text-decoration: none;
  text-transform: none;
  font-weight: 400;
  line-height: 40px;
  letter-spacing: 0px;
}

.taption .feature-page h2,
.taption .feature-page h4 {
  font-size: 26px;
  text-decoration: none;
  text-transform: none;
  color:#242424;
  letter-spacing: 1px;
  margin-bottom: 0px;
  line-height: 33px!important;
}

.taption .feature-page h3{
  color:#242424;
}

.feature-section {
  margin: 0 auto;
  padding-bottom:40px;
}

.feature-page video{
    border-radius: 10px;
}


.feature-page{
    margin-bottom: 40px;
}

.feature-page p{
    font-size:20px;
}

.feature-page .btn{
    /* margin: 0 auto; */
    display: inline-block!important;
    margin-top: 20px;
    margin-bottom: 30px;
    text-transform: none;
    color: #fff;
    background-color: #3ccebd;
    transition: all .3s ease-in-out;
    cursor: pointer;
    text-transform: uppercase;
    padding: 10px 25px;
    border: none;
    border-radius: 5px;
    font-size: 16px;
    width:auto!important;
}

.feature-page ul h2{
    margin-bottom: 0;
    color: black;
    font-weight: bold;
    letter-spacing: 0px;
    font-size: 20px;
    line-height: 0px;
}

.feature-page li,
.feature-page span,
.feature-page h4,
.feature-page p{
    color:#242424!important;
}


.feature-page li{
    text-align: left;
}

a.link{
    color: #3ccebd;
    font-weight: bold;
}

.feature-page .bullet-point{
    font-size: 40px;
    color: #3ccebd!important;
    line-height: 0px;
    margin-bottom: -2px;
    vertical-align: sub;
    display: inline-block;
}

@media (max-width: 992px) {
.taption .feature-page h1{
    font-size:40px!important;
}
.taption .feature-page h2{
    font-size:25px!important;
}
}

</style>